import { ReactElement, cloneElement } from "react";
import { Text } from "@chakra-ui/react";
import { GradientBorderContainer } from "../../containers/GradientBorderContainer";

export function ReleaseTypeBanner({
  text,
  icon,
  topColor,
  bottomColor,
  backgroundColor,
}: {
  text: string | ReactElement;
  icon: ReactElement;
  topColor: string;
  bottomColor: string;
  backgroundColor: string;
}) {
  return (
    <GradientBorderContainer
      position="relative"
      p="12px 16px"
      width="100%"
      borderRadius="8px"
      alignItems="center"
      justifyContent="center"
      gap="8px"
      backgroundColor={backgroundColor}
      topColor={topColor}
      bottomColor={bottomColor}
    >
      {cloneElement(icon, { color: "neutral.200", boxSize: "16px" })}
      <Text fontSize="12px" lineHeight="150%" letterSpacing=".25px">
        {text}
      </Text>
    </GradientBorderContainer>
  );
}
